export const DOCUMENTS_LIST = "DOCUMENTS_LIST";
export const DOCUMENTS_LIST_SUCCESS = "DOCUMENTS_LIST_SUCCESS";
export const DOCUMENTS_LIST_FAIL = "DOCUMENTS_LIST_FAIL";

export const EDIT_DOCUMENTS = "EDIT_DOCUMENTS";
export const EDIT_DOCUMENTS_SUCCESS = "EDIT_DOCUMENTS_SUCCESS";
export const EDIT_DOCUMENTS_FAIL = "EDIT_DOCUMENTS_FAIL";

export const UPDATE_DOCUMENTS = "UPDATE_DOCUMENTS";
export const UPDATE_DOCUMENTS_SUCCESS = "UPDATE_DOCUMENTS_SUCCESS";
export const UPDATE_DOCUMENTS_FAIL = "UPDATE_DOCUMENTS_FAIL";

export const ADD_DOCUMENTS = "ADD_DOCUMENTS";
export const ADD_DOCUMENTS_SUCCESS = "ADD_DOCUMENTS_SUCCESS";
export const ADD_DOCUMENTS_FAIL = "ADD_DOCUMENTS_FAIL";

// export const BLOCK_UNBLOCK_USER = "BLOCK_UNBLOCK_USER";
// export const BLOCK_UNBLOCK_USER_SUCCESS = "BLOCK_UNBLOCK_USER_SUCCESS";
// export const BLOCK_UNBLOCK_USER_FAIL = "BLOCK_UNBLOCK_USER_FAIL";

export const DELETE_DOCUMENTS = "DELETE_DOCUMENTS";
export const DELETE_DOCUMENTS_SUCCESS = "DELETE_DOCUMENTS_SUCCESS";
export const DELETE_DOCUMENTS_FAIL = "DELETE_DOCUMENTS_FAIL";
